exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".video-js .vjs-quality-selector .vjs-menu-button {\n  font-size: 16px;\n  width: 30px;\n  margin: 0px;\n  padding: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/video-js-core/src/quality/base.css
// module id = 634
// module chunks = 0